import { Box, Flex, GridItem, Heading, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Text } from "@chakra-ui/react"
import { GoBriefcase, GoCalendar, GoWatch } from "react-icons/go"
import { MdHelpOutline, MdOutlineTimer, MdPinDrop } from "react-icons/md"
import { GetDateTimeFromTimestamp, GetDateTimeFromTimestampRounded, GetLongDateFormat } from "../../../../helpers/DateTimeHelpers"
import { IJobsheet } from "../../../../interfaces/jobsheets/IJobsheet"
import { useState } from "react"
import { BeautifyString } from "../../../../helpers/StringHelpers"

export const AppointmentDetails = ({jobsheet, showBilling}: { jobsheet: IJobsheet, showBilling: boolean }) => {
    const [timeInfoPopOpen, setTimeInfoPopOpen] = useState<boolean>(false);

    return (
        <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' h='full' w='full'>
            <Heading m={2} size='md' color='var(--Able-blue)' p={2} borderBottom='2px' borderColor='gray.200'>Appointment</Heading>

            <Flex w='full' p={3} direction={{ base: 'column', sm: 'row' }}>
                <Flex direction='column' h='full' justifyItems='space-between'>
                    <Flex pb={1}>
                        <GoBriefcase style={{ fontSize: '30px', paddingLeft: '3px' }} /> {/*Briefcase*/}
                        <Text ml={2}>Job Number: {jobsheet.id}</Text>
                    </Flex>

                    {jobsheet.appointment &&
                        <>
                            <Flex pb={1}>
                                <GoCalendar style={{ fontSize: '30.25px' }} /> {/*Calendar*/}
                                { jobsheet.appointment && <Text ml={2}>{GetLongDateFormat(jobsheet.appointment.date)}</Text> }
                            </Flex>

                            <Flex pb={1}>
                                <GoWatch style={{ fontSize: '30px', paddingLeft: "0.5px" }} /> {/*wristwatch*/}
                                <Text ml={2} mr={2}>{GetDateTimeFromTimestamp(jobsheet.appointment?.start_date, "LT")} - {GetDateTimeFromTimestamp(jobsheet.appointment?.end_date, "LT")}</Text>
                                <Popover isOpen={timeInfoPopOpen}>
                                    <PopoverTrigger>
                                        <Flex onMouseEnter={() => setTimeInfoPopOpen(true)} onMouseLeave={() => setTimeInfoPopOpen(false)} align='start'>
                                            <MdHelpOutline style={{ fontSize: '20px', color: 'var(--Able-blue)', marginTop: "3px" }} />
                                        </Flex>
                                    </PopoverTrigger>
                                    <PopoverContent>
                                        <PopoverArrow />
                                        <PopoverBody>
                                            <Text>
                                                Your appointment slot is the time window for the arrival of your engineer.
                                                This is not an estimate of how long the appointment will last.
                                            </Text>
                                        </PopoverBody>
                                    </PopoverContent>
                                </Popover>


                            </Flex>
                            {jobsheet.appointment?.eta &&
                                <Flex pb={1} marginLeft={"-2.5px"}>
                                    <MdOutlineTimer style={{ fontSize: '32px', paddingLeft: '3px' }} />
                                    <Text ml={"9px"} marginTop={"2px"}>Estimated Arrival: {" "}
                                        {GetDateTimeFromTimestampRounded(jobsheet.appointment.eta.time, "LT")}</Text>
                                </Flex>
                            }
                        </>
                    }
                </Flex>

                {showBilling &&                            
                    <Flex grow={1} justify={{ base: 'start', md: 'center' }}>
                        <MdPinDrop style={{ fontSize: '30px' }} />
                        <Flex direction='column' ml={2}>
                            <Text as='b'>Invoicing Address:</Text>
                            <Text textAlign='left'>{BeautifyString(jobsheet.customer?.Billing.Address.line1)}</Text>
                            <Text textAlign='left'>{BeautifyString(jobsheet.customer?.Billing.Address.line2)}</Text>
                            <Text textAlign='left'>{BeautifyString(jobsheet.customer?.Billing.Address.line3)}</Text>
                            <Text textAlign='left'>{BeautifyString(jobsheet.customer?.Billing.Address.line4)}</Text>
                            <Text textAlign='left'>{jobsheet.customer?.Billing.Address.post_code}</Text>
                        </Flex>
                    </Flex>
                }

                <Flex grow={1} justify={{ base: 'start', md: 'center' }}>
                    <MdPinDrop style={{ fontSize: '30px' }} />
                    <Flex direction='column' ml={2}>
                        <Text as='b'>Site Address:</Text>
                        <Text textAlign='left'>{BeautifyString(jobsheet.address.line1)}</Text>
                        <Text textAlign='left'>{BeautifyString(jobsheet.address.line2)}</Text>
                        <Text textAlign='left'>{BeautifyString(jobsheet.address.line3)}</Text>
                        <Text textAlign='left'>{BeautifyString(jobsheet.address.line4)}</Text>
                        <Text textAlign='left'>{jobsheet.address.post_code}</Text>
                    </Flex>
                </Flex>
            </Flex>
        </Box>
    )
}